import { ref } from "vue";

/*********************************************************************/
//                       NON-REACTIVE CONSTANTS                      //
/*********************************************************************/
import { consoleLoggerFactory, getDefaultLoggerOptions, ILogger, LogLevels } from "@/types/console-logger";
const logger: ILogger = consoleLoggerFactory.create( getDefaultLoggerOptions( LogLevels.ERROR ) );

/*********************************************************************/
//                 GLOBALLY SHARED REACTIVE VARIABLES                //
/*********************************************************************/
// The page size reactive variable is used as a paging aid when calculating the index for the
// start of the currently selected page of data
const pageSize = ref< number >( 8 );

// The page number reactive variable is partially controlled by the paging component which is
// why it is used as the v-model for the paging component
const pageNumber = ref< number >( 0 );

/*********************************************************************/
//                      INSTANCE SPECIFIC STATE
/*********************************************************************/
export function usePagingFilter() {
    function filteredContentPage< T >( content: T[] ): T[] {
        // Skip the number of items as the page size * 1 - the page #
        const fromInclusive: number = ( pageNumber.value );
        logger.debug( '[ paging-filter ].filteredContentPage -> fromInclusive: ', fromInclusive );
        const toExclusive: number = fromInclusive + pageSize.value;
        logger.debug( '[ paging-filter ].filteredContentPage -> toExclusive: ', toExclusive );

        logger.debug( '[ paging-filter ].filteredContentPage -> filteredContentPage: ', content );

        return content.slice( fromInclusive, toExclusive );
    }

    function resetPageNumber() {
        pageNumber.value = 0;
    }

    return {
        // ACTIONS
        filteredContentPage,
        resetPageNumber,

        // GETTERS
        pageNumber,
        pageSize
    }
}

export type PagingFilter = ReturnType< typeof usePagingFilter >;
